import { put, call, fork, select, takeEvery, all } from 'redux-saga/effects';

import * as offersModule from '../modules/offers.module';
import * as Api from '../../core/api';

export function* fetchOffers({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.offers.sort);
  const filter = yield select((state) => state.offers.filter);
  const { response, error } =
    yield call(Api.offers.fetchOffers, { page, itemsPerPage, sort, filter });

  if (response) {
    yield put(offersModule.fetchOffersSuccess(response));
  } else {
    yield put(offersModule.fetchOffersFail(error));
  }
}
export function* watchFetchOffers() {
  yield takeEvery(offersModule.fetchOffers.getType(), fetchOffers);
}

export default function* watchOffers() {
  return yield all([
    fork(watchFetchOffers),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/offers.saga.js
 **/